import { Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import SelectFormItem from "components/Input/Select";
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { CheckboxFormItem, InputNumberForm, RadioForm, TextBoxForm } from "components/Input";
import Divider from "components/Divider";
import "./Register.css";
import { FiArrowRight, FiArrowLeft } from "react-icons/fi";
import React, { useState } from "react";
import { RegisterContext } from "..";
import { ColumnProps } from "components/TableUI/TableUI";
import { BtnAdd, BtnDeleteTable, BtnEditTable, BtnSaveIcon, BtnCancelIcon } from "components/Button";
import TableUI from "components/TableUI";
import { CheckboxGroupFormItem } from "components/Input/Checkbox";
import { DatePickerFromItem } from "components/Input/DatePicker";
import { AiFillEdit } from "react-icons/ai";
import { List } from "linqts";
import { undefinedOrNull } from "utilities/Function";
import { TLanguageAbility } from "./RegisterClass";
import { SwAlert } from "components/Alert";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
const StepForm4 = () => {
  const { handleNext, handleBack, objMasterData, formStep4, arrLanguageAbility, setarrLanguageAbility } = React.useContext(RegisterContext);
  const [open, setOpen] = React.useState(false);
  const [nEditID, setnEditID] = useState(null);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const objSchema = yup.object().shape({
    nlanguageID: yupFormSchemas.string("ภาษา", { required: true }),
    nSpeakingID: yupFormSchemas.string("การพูด", { required: true }),
    nReadingID: yupFormSchemas.string("การอ่าน", { required: true }),
    nWritingID: yupFormSchemas.string("การเขียน", { required: true }),
    nListenID: yupFormSchemas.string("การฟัง", { required: true }),
  });

  const form = useForm({
    resolver: yupResolver(objSchema),
    shouldUnregister: false,
    shouldFocusError: true,
    mode: "all",
  });
  const ColumnData: ColumnProps[] = [{
    id: "nNo",
    name: "ลำดับ",
    width: "5%",
  },
  {
    id: "slanguageName",
    name: "ภาษา",
    width: "30%",
    cellAlign: "center"
  },
  {
    id: "sSpeakingName",
    name: "การพูด",
    width: "10%",
    cellAlign: "center"
  },
  {
    id: "sReadingName",
    name: "การอ่าน",
    width: "10%",
    cellAlign: "center"
  },
  {
    id: "sWritingName",
    name: "การเขียน",
    width: "10%",
    cellAlign: "center"
  },
  {
    id: "sListenName",
    name: "การฟัง",
    width: "10%",
    cellAlign: "center"
  },
  {
    id: "Action",
    name: "",
    width: "5%",
    renderCell: (item) => {
      return (
        <div style={{ display: "inline-flex", textAlign: "center" }}>
          <BtnEditTable onClick={() => { onEdit(item) }} />
          <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDelete(item) }} />
        </div>
      )
    }
  }]

  const handleClose = (event: object, reason: string) => {
    if (reason != "backdropClick") {
      form.setValue("nlanguageID", null);
      form.setValue("nSpeakingID", null);
      form.setValue("nReadingID", null);
      form.setValue("nWritingID", null);
      form.setValue("nListenID", null);
      form.setValue("nToeic", null);
      form.setValue("nToefl", null);
      form.clearErrors();
      setnEditID(null);
      setOpen(false);
    }
  };
  const onDelete = (obj: TLanguageAbility) => {
    SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
      setarrLanguageAbility(new List<TLanguageAbility>(arrLanguageAbility || []).Where(w => w.nlanguageID != obj.nlanguageID).ToArray())
    });
  }
  const onEdit = (obj: TLanguageAbility) => {
    setnEditID(obj.nlanguageID);
    form.setValue("nlanguageID", undefinedOrNull(obj.nlanguageID, "string"));
    form.setValue("nSpeakingID", undefinedOrNull(obj.nSpeakingID, "string"));
    form.setValue("nReadingID", undefinedOrNull(obj.nReadingID, "string"));
    form.setValue("nWritingID", undefinedOrNull(obj.nWritingID, "string"));
    form.setValue("nListenID", undefinedOrNull(obj.nListenID, "string"));
    form.setValue("nToeic", undefinedOrNull(obj.nToeic, "string"));
    form.setValue("nToefl", undefinedOrNull(obj.nToefl, "string"));
    handleClickOpen();
  }
  const onSave = () => {
    let qlanguage = new List<any>(objMasterData.lstLanguage || []).FirstOrDefault(w => w.value == form.getValues("nlanguageID"));
    let qSpeaking = new List<any>(objMasterData.lstSkillLevel || []).FirstOrDefault(w => w.value == form.getValues("nSpeakingID"));
    let qReading = new List<any>(objMasterData.lstSkillLevel || []).FirstOrDefault(w => w.value == form.getValues("nReadingID"));
    let qWriting = new List<any>(objMasterData.lstSkillLevel || []).FirstOrDefault(w => w.value == form.getValues("nWritingID"));
    let qListen = new List<any>(objMasterData.lstSkillLevel || []).FirstOrDefault(w => w.value == form.getValues("nListenID"));
    if (nEditID) {
      let qStudy = new List<TLanguageAbility>(arrLanguageAbility || []).FirstOrDefault(w => w.nlanguageID == nEditID);
      if (qStudy) {
        qStudy.nSpeakingID = undefinedOrNull(form.getValues("nSpeakingID"), "number");
        qStudy.nReadingID = undefinedOrNull(form.getValues("nReadingID"), "number");
        qStudy.nWritingID = undefinedOrNull(form.getValues("nWritingID"), "number");
        qStudy.nListenID = undefinedOrNull(form.getValues("nListenID"), "number");
        qStudy.slanguageName = qlanguage ? qlanguage.label : "";
        qStudy.sSpeakingName = qSpeaking ? qSpeaking.label : "";
        qStudy.sReadingName = qReading ? qReading.label : "";
        qStudy.sWritingName = qWriting ? qWriting.label : "";
        qStudy.sListenName = qListen ? qListen.label : "";
        qStudy.nToeic = undefinedOrNull(form.getValues("nToeic"), "number");
        qStudy.nToefl = undefinedOrNull(form.getValues("nToefl"), "number");
      }
      handleClose(null, "");
    } else {
      let lstarrStudy = new List<TLanguageAbility>(arrLanguageAbility || []).ToList();
      if (lstarrStudy.Any(a => a.nlanguageID === undefinedOrNull(form.getValues("nlanguageID"), "number"))) {
        SwAlert.Warning(AlertTitle.Warning, "ท่านได้ทำการระบุความสามารถด้านภาษา" + (qlanguage ? qlanguage.label : "") + "ไปแล้ว", () => { });
      } else {
        let MaxNo = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nNo) + 1 : 1
        let data: TLanguageAbility = {
          nlanguageID: undefinedOrNull(form.getValues("nlanguageID"), "number"),
          nNo: MaxNo,
          nSpeakingID: undefinedOrNull(form.getValues("nSpeakingID"), "number"),
          nReadingID: undefinedOrNull(form.getValues("nReadingID"), "number"),
          nWritingID: undefinedOrNull(form.getValues("nWritingID"), "number"),
          nListenID: undefinedOrNull(form.getValues("nListenID"), "number"),
          nToeic: undefinedOrNull(form.getValues("nToeic"), "number"),
          nToefl: undefinedOrNull(form.getValues("nToefl"), "number"),
          nOrderID: MaxNo,
          slanguageName: qlanguage ? qlanguage.label : "",
          sSpeakingName: qSpeaking ? qSpeaking.label : "",
          sReadingName: qReading ? qReading.label : "",
          sWritingName: qWriting ? qWriting.label : "",
          sListenName: qListen ? qListen.label : "",
        }
        setarrLanguageAbility([...arrLanguageAbility, { ...data }])
        handleClose(null, "");
      }
    }

  };
  const onClickNext = () => {
    if ((arrLanguageAbility || []).length > 0) {
      handleNext()
    } else {
      SwAlert.Warning(AlertTitle.Warning, "กรุณาระบุความสามารถด้านภาษาของท่าน", () => { });
    }
  }
  return (
    <>
      <FormProvider {...formStep4}>
        <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1}>
          <Grid item md={12} xs={12}>
            <Divider>ความสามารถพิมพ์ดีด</Divider>
          </Grid>
          <Grid item md={6} xs={12}>
            <InputNumberForm name={"nTypingAbility_TH"} label={"ไทย"} endAdornment={<div style={{ fontSize: "0.8em", width: "55px" }}>คำ/นาที</div>} required />
          </Grid>
          <Grid item md={6} xs={12}>
            <InputNumberForm name={"nTypingAbility_EN"} label={"อังกฤษ"} endAdornment={<div style={{ fontSize: "0.8em", width: "55px" }}>คำ/นาที</div>} required />
          </Grid>
          <Grid item md={6} xs={12}>
            <RadioForm name={"isInternet"} label={"Internet/Email"} options={[{ label: "ได้", value: "1" }, { label: "ไม่ได้", value: "0" }]} isShowRow required />
          </Grid>
          <Grid item md={12} xs={12}>
            <Divider>ความสามารถด้านภาษา</Divider>
          </Grid>
          <Grid item md={12} xs={12}>
            <TableUI column={ColumnData || []}
              row={arrLanguageAbility || []} />
          </Grid>
          <Grid item md={12} xs={12}>
            <BtnAdd onClick={handleClickOpen} />
          </Grid>
          <Grid item md={12} xs={12}>
            <CheckboxGroupFormItem label="โปรแกรมคอมพิวเตอร์ที่ใช้ได้" name={"arrComputerPrograml"} options={objMasterData.lstComputerPrograml || []} />
          </Grid>
          <Grid item md={12} xs={12}>
            <TextBoxForm name={"sOtherAbilities"} label={"ความสามารถอื่นๆ"} multiline rows={3} />
          </Grid>
          <Grid item md={6} xs={6}>
            <Grid marginTop={4} container direction="row" alignItems="start" justifyContent="start" sx={{}}>
              <button className="buttonBack" onClick={handleBack}>
                <FiArrowLeft />
                <span>กลับ</span>
              </button>
            </Grid>
          </Grid>
          <Grid item md={6} xs={6}>
            <Grid marginTop={4} container direction="row" alignItems="end" justifyContent="end" sx={{}}>
              <button className="buttonNext" onClick={formStep4.handleSubmit(() => { onClickNext(); })}>
                <span>ต่อไป</span>
                <FiArrowRight />
              </button>
            </Grid>
          </Grid>
        </Grid>
      </FormProvider>

      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        sx={{ borderRadius: "23px", zIndex: "1" }}
      >
        <DialogTitle style={{
          borderBottom: "1px solid #FD8D14"
        }}><AiFillEdit /> ความสามารถด้านภาษา</DialogTitle>
        <DialogContent>
          {/* <Box
            noValidate
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: 'fit-content',
            }}
          > */}
          <FormProvider {...form}>
            <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
              <Grid item md={4} xs={12}>
                <SelectFormItem options={objMasterData.lstLanguage || []} name={"nlanguageID"} label={"ภาษา "} required disabled={nEditID != null} />
              </Grid>
              <Grid item md={4} xs={12}>
                <InputNumberForm name={"nToeic"} label={"Toeic score"} maxDigits={2}/>
              </Grid>
              <Grid item md={4} xs={12}>
                <InputNumberForm name={"nToefl"} label={"Toefl score"} maxDigits={2}/>
              </Grid>

              <Grid item md={3} xs={12}>
                <SelectFormItem options={objMasterData.lstSkillLevel || []} name={"nSpeakingID"} label={"การพูด"} required />
              </Grid>
              <Grid item md={3} xs={12}>
                <SelectFormItem options={objMasterData.lstSkillLevel || []} name={"nReadingID"} label={"การอ่าน"} required />
              </Grid>
              <Grid item md={3} xs={12}>
                <SelectFormItem options={objMasterData.lstSkillLevel || []} name={"nWritingID"} label={"การเขียน "} required />
              </Grid>
              <Grid item md={3} xs={12}>
                <SelectFormItem options={objMasterData.lstSkillLevel || []} name={"nListenID"} label={"การฟัง"} required />
              </Grid>
            </Grid>
          </FormProvider>
          {/* </Box> */}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Close</Button> */}
          <BtnCancelIcon onClick={() => handleClose({}, "")} />
          <BtnSaveIcon onClick={form.handleSubmit(() => { onSave(); })} />
        </DialogActions>
      </Dialog>

    </>
  )
};

export default StepForm4;
